<template>
  <div class="card-item card-item-positioning">
    <icon-positioning class="icon" v-ifield-b-tooltip="iconTooltipText" />
    <span
      ref="truncTarget"
      class="text ellipsis"
      v-ifield-b-tooltip="tooltipOption"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import { toRefs } from 'vue'
import IconPositioning from '@/assets/ifield/ic_positioning-time.svg?component'
import { useIsTruncated } from '@/composables/UseIsTruncated'
import { useUserStatusAdditionalItemPositioning } from '@/composables/user/additionalItem'

export default {
  name: 'AppCardMemberItemPositioning',
  components: {
    IconPositioning,
  },
  inheritAttrs: false,
  props: {
    /**
     * 測位日時
     */
    at: {
      type: String,
      default: null,
    },
    /**
     * 基準日時
     * * 経過日数表記を更新したい場合は値を変更する
     * * binding されない場合、経過日数はマウント時の現在時刻での計算以降変化しない
     */
    baseDate: {
      type: Date,
      default: null,
    },
  },
  setup(props) {
    const { at, baseDate } = toRefs(props)
    const { truncTarget, isTruncated } = useIsTruncated()
    const { text } = useUserStatusAdditionalItemPositioning({ at, baseDate })
    return { truncTarget, isTruncated, text }
  },
  computed: {
    /**
     * アイコン部ツールチップテキスト
     * @type {string}
     */
    iconTooltipText: function () {
      return `${this.$t('appCardMemberItemPositioning.positioningDate')} : ${
        this.text
      }`
    },
    /**
     * ツールチップオプション
     * @type {Object}
     */
    tooltipOption: function () {
      return {
        title: this.text,
        disabled: !this.isTruncated,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/member/card-member-item';
</style>
